module.exports = "/_next/static/images/in-bdfaaf97045e7179c59f02bb5ad4c98c.svg";